import { selectors } from '@sloyd/store-base';
import '@sloyd/types';
import { bridge } from '@sloyd/viewer';
import { select } from 'saga-ts';

export function* onSlotRestore(ev: any) {
  const { data } = ev;
  const transparencies = yield* select(selectors.single.$currentTransparencies);

  [0, 1, 2, 3].forEach((i) => {
    bridge.patchMaterial('main', i, { transparency: transparencies[i] });
  });
}

export function* onSlotHover(ev: any) {
  const { data } = ev;
  const { index } = data;

  bridge.slotResetAll('main');

  if (index === undefined) {
    return;
  }

  bridge.slotShow('main', index);
}
